import styled from 'styled-components';

const HeaderText = styled.div`
  color: var(--grey500);
  font-size: 12px;
  font-weight: 500;
`;
export default HeaderText;
